module.exports = __webpack_public_path__ + "img/c3def7a.jpg";